import { ChevronUp, ChevronDown } from "lucide-react";
import React from "react";
import clsx from "clsx";

type IncrementDecrementProps = {
  className?: string;
  increment: () => void;
  decrement: () => void;
  upArrowSize?: number;
  downArrowSize?: number;
  arrowGapSize?: number;
  disabled?: boolean;
};

const IncrementDecrement = ({
  className,
  increment,
  decrement,
  upArrowSize = 12,
  downArrowSize = 12,
  arrowGapSize = 0.5,
  disabled = false,
}: IncrementDecrementProps) => {
  return (
    <div className={clsx("flex items-center", className)} onMouseDown={(e) => e.preventDefault()}>
      <div className={`flex flex-col items-center space-y-${arrowGapSize}`}>
        <ChevronUp
          onClick={disabled ? undefined : increment}
          size={upArrowSize}
          className={disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"}
        />
        <ChevronDown
          onClick={disabled ? undefined : decrement}
          size={downArrowSize}
          className={disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"}
        />
      </div>
    </div>
  );
};

export default IncrementDecrement;
